import './App.css';
import React from 'react';
import { Route, Switch, Redirect, Router } from "react-router-dom";
import History from './History';

import OiPin from './components/oiPin/oiPin';
import OiLogin from './components/oiLogin/oiLogin';
import OiAbout from './components/oiAbout/oiAbout';
import OiChoice from './components/oiLogin/oiChoice';
import OiProfile from './components/oiProfile/oiProfile';
import OiNewsPage from './components/oiNewsPage/oiNewsPage';
import OiTimeline from './components/oiTimeline/oiTimeline';
import OiInterests from './components/oiInterests/oiInterests';

import UserAccessControl from './userAccessControl';

const App = (props) => {
  return (
    <div className="App">
      <UserAccessControl />
      <Router history={History}>
        <Switch>
          <Route path={`${process.env.PUBLIC_URL}/`} exact component={OiChoice} />
          <Route path={`${process.env.PUBLIC_URL}/login`} exact component={OiLogin} />
          <Route path={`${process.env.PUBLIC_URL}/confirmacao`} exact component={OiPin} />
          <Route path={`${process.env.PUBLIC_URL}/interesses`} exact component={OiInterests} />
          <Route path={`${process.env.PUBLIC_URL}/noticias`} exact component={OiTimeline} />
          <Route path={`${process.env.PUBLIC_URL}/sobre`} exact component={OiAbout} />
          <Route path={`${process.env.PUBLIC_URL}/noticia`} exact component={OiNewsPage} />
          <Route path={`${process.env.PUBLIC_URL}/perfil`} exact component={OiProfile} />
          <Redirect from="*" to={`${process.env.PUBLIC_URL}/`} />
        </Switch>
      </Router>
    </div>
  );
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js